import Axios  from 'axios';
import { TokenHelper } from './token-helper';

let initialized = false;

export function UseAxios(router) {

  if (!initialized) {

    Axios.interceptors.request.use((config) => {
       if (!config.headers['Authorization']) {   // append authorization header
          let bearerToken = TokenHelper.getBearerToken();

         if (bearerToken.Authorization)
           Object.assign(config.headers, bearerToken);
       }

      if (!config.maxRedirects || config.maxRedirects === 5)  // ensure axios does not follow redirects, so custom response interceptor below can push to app login page
        config.maxRedirects = 0;

      return config;
    });

    Axios.interceptors.response.use(undefined, (config) => {
      if (config.response) {
        let response = config.response;
        if (response.status === 401) {
          let location = response.headers['location'] || response.headers['Location'];

          if (location) {
            let redirectTo = '/' + location;
            window.setTimeout(() => router.replace(redirectTo), 200);
          }
        }
      }

      return config;
    });

    initialized = true;
  }
};



// WEBPACK FOOTER //
// ./src/common/axiosuse.js